import React from 'react';
import { useUserContext } from 'common/contexts/UserContext';
import { Button } from '@mui/material';

const ComponentPreview: React.FC = () => {
  const { user } = useUserContext();
  return (
    <>
      <h1>TypeScript</h1>
      <div>REACT_APP_ENV: {process.env.REACT_APP_ENV}</div>
      <div className="flex">
        <Button variant="contained" color="primary">
          primary
        </Button>
        <Button variant="contained" color="primary" disabled>
          primary disabled
        </Button>
        <Button variant="outlined" color="primary">
          primary
        </Button>
        <Button variant="outlined" color="primary" disabled>
          primary disabled
        </Button>
      </div>
      <div className="flex">
        <Button variant="contained" color="secondary">
          secondary
        </Button>
        <Button variant="contained" color="secondary" disabled>
          secondary disabled
        </Button>
        <Button variant="outlined" color="secondary">
          secondary
        </Button>
        <Button variant="outlined" color="secondary" disabled>
          secondary disabled
        </Button>
      </div>
      <div className="flex">
        <Button variant="contained" color="info">
          info
        </Button>
        <Button variant="contained" color="info" disabled>
          disabled info
        </Button>
        <Button variant="outlined" color="info">
          info
        </Button>
        <Button variant="outlined" color="info" disabled>
          disabled info
        </Button>
      </div>
      <div>
        <Button variant="contained" color="error">
          error
        </Button>
        <Button variant="contained" color="error" disabled>
          error disabled
        </Button>
        <Button variant="outlined" color="error">
          error
        </Button>
        <Button variant="outlined" color="error" disabled>
          error disabled
        </Button>
      </div>{' '}
      <pre>{JSON.stringify(user, null, 2)}</pre>
    </>
  );
};
ComponentPreview.displayName = 'ComponentPreview';

export default ComponentPreview;
